import PullTo from './vue-pull-to.vue';

export default PullTo;



// WEBPACK FOOTER //
// ./src/components/pull/src/index.js